import { Text } from '@avanta/shared/components/Text';
import { Button } from '@avanta/shared/components/ui/Button';
import { FLOW_MODES } from '@avanta/shared/constants/appointments';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AppointmentsReservePayload, type AppointmentsReserveFormData } from '../../../../types';

export const SearchPsychologistBanner = (): React.ReactElement | null => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { reset, watch } = useFormContext<AppointmentsReserveFormData>();
  const flow = watch(AppointmentsReservePayload.flow);

  if (flow === FLOW_MODES.search || flow === FLOW_MODES.edit) return null;

  const handleClick = (): void => {
    reset(formValues => ({
      ...formValues,
      [AppointmentsReservePayload.specialityBooked]: undefined,
      [AppointmentsReservePayload.psychologistServiceBooked]: undefined,
      [AppointmentsReservePayload.city]: '',
      [AppointmentsReservePayload.backofficeCenterId]: '',
      [AppointmentsReservePayload.dateTime]: '',
      [AppointmentsReservePayload.psychologist]: undefined,
      [AppointmentsReservePayload.flow]: FLOW_MODES.search,
    }));
  };

  return (
    <div className="w-full bg-plum-100 pl-4 pr-6 py-3 flex justify-between items-center rounded-xl">
      <div>
        <Text variant="text-sm-medium" className="text-denim-800">
          {t('AppointmentsReserve.SearchPsychologistBanner.title')}
        </Text>
        <Text variant="text-sm-medium" className="text-denim-800">
          {t('AppointmentsReserve.SearchPsychologist.description')}
        </Text>
      </div>
      <Button
        variant="link"
        className="text-teal-600 underline underline-offset-2 font-medium text-sm leading-4 hover:text-teal-500 p-0"
        onClick={handleClick}
      >
        {t('AppointmentsReserve.SearchPsychologist.cta')}
      </Button>
    </div>
  );
};
